import { Component, Input, OnChanges, ChangeDetectionStrategy, numberAttribute } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import * as QRCode from 'qrcode';

@Component({
    selector: 'qrcode-svg',
    template: `<div [innerHTML]="svg"></div>`,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class QrcodeSvgComponent implements OnChanges {
  @Input() public value: string;
  @Input() public errorCorrectionLevel: 'L' | 'M' | 'Q' | 'H' = 'M';
  @Input({ transform: numberAttribute }) public margin = 4;

  public svg: SafeHtml;

  constructor(private domSanitizer: DomSanitizer) { }

  public ngOnChanges(): void {
    if (!this.value) {
      this.svg = '';
      return;
    }
    const requestedValue = this.value;
    QRCode.toString(requestedValue, {
      type: 'svg',
      errorCorrectionLevel: this.errorCorrectionLevel,
      margin: this.margin
    }).then(svgMarkup => {
      if (requestedValue !== this.value) {
        return;
      }
      this.svg = this.domSanitizer.bypassSecurityTrustHtml(svgMarkup);
    }).catch(() => {
      if (requestedValue === this.value) {
        this.svg = '';
      }
    });
  }
}
